import UbahTemplatePenunjangProduksi from './UbahTemplatePenunjangProduksi';

export default UbahTemplatePenunjangProduksi;
